import { TimeManagementListItem } from '@myapp/contract'
import { getLeftPercent, getWidthPercent } from './timelineConstants'
import { SegmentedBlock, Segment } from './SegmentedBlock'
import { TIME_ENTRY_CATEGORY_COLOR, getTimeEntryCategoryLabel } from '../../../entities/time-entry'
import { formatTimeHHmm } from '../../../shared/lib/timeline/dateHelpers'

interface Props {
  entry: TimeManagementListItem
  dayIso: string
  shiftStartHour?: number
  shiftEndHour?: number
  onClick?: (id: number) => void
  laneIndex?: number
  laneCount?: number
}

export const TimeManagementBlock = ({ entry, dayIso, shiftStartHour, shiftEndHour, onClick, laneIndex, laneCount }: Props) => {
  const base = new Date(dayIso)
  const clampStart = new Date(base)
  clampStart.setHours(
    shiftStartHour != null ? Math.floor(shiftStartHour) : 0,
    shiftStartHour != null ? Math.round((shiftStartHour % 1) * 60) : 0,
    0, 0,
  )
  const clampEnd = new Date(base)
  clampEnd.setHours(
    shiftEndHour != null ? Math.floor(shiftEndHour) : 23,
    shiftEndHour != null ? Math.round((shiftEndHour % 1) * 60) : 59,
    shiftEndHour != null ? 0 : 59,
    shiftEndHour != null ? 0 : 999,
  )

  const effectiveStart = new Date(Math.max(new Date(entry.startTime).getTime(), clampStart.getTime()))
  const effectiveEnd = new Date(Math.min(new Date(entry.endTime).getTime(), clampEnd.getTime()))
  const durationMinutes = Math.round((effectiveEnd.getTime() - effectiveStart.getTime()) / 60_000)

  const left = getLeftPercent(effectiveStart.toISOString())
  const width = getWidthPercent(durationMinutes)

  const segments: Segment[] = [
    { duration: durationMinutes, color: TIME_ENTRY_CATEGORY_COLOR, topLabel: formatTimeHHmm(effectiveStart.toISOString()), label: getTimeEntryCategoryLabel(entry.category) },
  ]

  return (
    <SegmentedBlock
      segments={segments}
      left={left}
      width={width}
      className={onClick ? 'cursor-pointer' : ''}
      onMouseDown={onClick ? (e) => { e.stopPropagation(); onClick(entry.id) } : undefined}
      laneIndex={laneIndex}
      laneCount={laneCount}
    />
  )
}
